<app-navigation *ngIf="isAuthorized && !hideComponents" [@show] [mobileClicked]="openMobile"
  (hideBackground)="appBackgroundChange()">

</app-navigation>
<div [ngClass]="hideComponents ? 'container--full' : ' '" class="container-fluid container--wrapper"
  *ngIf="isAuthorized" [@show]>
  <div *ngIf="isAuthorized && !hideComponents" class="container__header">
    <div class="container--row row container--mobile">
      <div class="input-group col-xl-3 col-lg-3">
        <img class="mobile__menu" (click)="mobileToggle()" src="../assets/images/ham-menu.svg" />
      </div>

    </div>
    <div class="container--row row container--desktop">
      <!-- <div class="input-group col-xl-6 col-lg-6">

      </div>
      <div class="col-xl-2 offset-xl-4 col-lg-2 offset-lg-4">
        <div *ngIf="profile" class="container__header__profile float-right">
          <span [style.background-image]="'url('+profile?.picture+')'" class="
            container__header__profile__avatar"></span>
          <div class="dropdown">
            <button class="btn btn--transparent dropdown-toggle" type="button" id="dropdownProfile"
              data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
              <span class="container__header__profile__name">{{profile.name}}</span>
            </button>
            <div class="dropdown-menu dropdown-menu-left" aria-labelledby="dropdownProfile">
              <span class="dropdown-item" (click)="logOut()" translate>Logout</span>
            </div>
          </div>
        </div>
      </div> -->

      <div class="container text-center">
        <div class="row">
          <div class="col"></div>
          <div class="col-md-auto">
            <div *ngIf="profile" class="container__header__profile float-right">
              <span [style.background-image]="'url('+profile.picture+')'" class="container__header__profile__avatar"></span>
              <div class="dropdown">
                <a class="btn btn--transparent dropdown-toggle" href="#" role="button" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false" id="dropdownProfile">
                  <span class="container__header__profile__name">{{profile.name}}</span>
                </a>
                <ul class="dropdown-menu dropdown-menu-left" aria-labelledby="dropdownProfile">
                  <li><a class="dropdown-item" href="#" (click)="logOut()">Logout</a></li>
                </ul>
              </div>
            </div>
          </div>
        </div>

      </div>

    </div>
  </div>

  <div *ngIf="isAuthorized" [@show] class="container--content">
    <router-outlet></router-outlet>
  </div>

</div>
<div *ngIf="savingBool" [@fadeInOut] class="global__spinner" translate>Saving</div>
<div *ngIf="errorBool" [@fadeInOut] class="global__spinner global__spinner-error" translate>An unexpected error occured.
</div>
<div *ngIf="!isAuthorized" class="splash__screen">
  <span class="splash__logo"></span>
  <div class="loading__animation">
    <li class="dot"></li>
    <li class="dot"></li>
    <li class="dot"></li>
  </div>
</div>
<div (window:resize)="onResize($event)" class="backdrop-mobile" (click)="navigationNotify()"
  [ngClass]="appMobile ? 'active-backdrop-mobile' : 'closedMobile'">
</div>